import React, { useState, useRef }from 'react';
import Form from './components/Form';
import RegistroList from './components/RegistroList';
import RegistroCard from './components/RegistroCard';


function App() {
  const [registros, setRegistros] = useState([]);
  const registroCardRef = useRef(null);

  const handleData = (data) => {
    setRegistros(data);    
    setTimeout(() => {
      if (data.length === 1 && registroCardRef.current) {
        registroCardRef.current.focus();
      }
    }, 0);
  };
  const limpiarRegistros = () => {    
    setRegistros([]);     

  };

  return (

    <main role="main" className="main-gray">
    <section>
      <div id="contenedorCont" className="container">
        <div className="row">
          <div className="col-xs-12">            
            <Form onData={handleData} onClear={limpiarRegistros} />
            {registros.length === 1 && <RegistroCard ref={registroCardRef} registro={registros} />}
            {registros.length > 1 && <RegistroList registros={registros} />}            
          </div>
        </div>
      </div>
    </section>
  </main>

  );
}

export default App;

